import { inject, NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';

@NgModule({
  imports: [MatIconModule],
  exports: [MatIconModule],
  providers: [MatIconRegistry]
})
export class TiimeIconModule {
  readonly matIconRegistry = inject(MatIconRegistry);

  constructor() {
    const matIconRegistry = this.matIconRegistry;

    matIconRegistry.setDefaultFontSetClass('tiime-fontastic');
  }
}
